<div *ngIf="!goToCivitek && !goToFortPoint">
    <div class="form-display-card">
      <mat-card class='mat-card-display mb-5'>
        <mat-card-header>
          <mat-card-title class="justify-content-start">
            <h2 class="mat-card-title align-items-start">
              <span class="fa fa-credit-card fa-md-black mr-2"></span> Review Credit Card Payment Information
            </h2>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="mb-5">
            <table class="table">
              <thead>
                <tr>
                  <th *ngFor="let col of paymentheader">{{col}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let payment of creditCardPayment?.participantCollection">
                  <td>{{payment.lastName}}</td>
                  <td>{{payment.ssn}}</td>
                  <td>{{payment.caseNumber}}</td>
                  <td>{{payment.amount | currency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col mb-3">
            <dl class="account-details-sum">
              <div class="account-sum-row">
                <dt class="account-dt">Payment Amount</dt>
                <dd class="account-dt-info">{{creditCardPayment?.amount | currency}}</dd>
              </div>
              <div class="account-sum-row">
                <dt class="account-dt">Service Fee %</dt>
                <dd class="account-dt-info">{{creditCardPayment?.feePercentage | percent: '.2'}}</dd>
              </div>
              <div class="account-sum-row">
                <dt class="account-dt">Service Fee Amount</dt>
                <dd class="account-dt-info">{{creditCardPayment?.fee | currency}}</dd>
              </div>
              <div class="account-sum-row">
                <dt class="account-dt">Total Credit Card Amount</dt>
                <dd class="account-dt-info">{{creditCardPayment?.totalAmount | currency}}</dd>
              </div>
            </dl>
          </div>
  
          <div class="pt-2 pb-2">
            <div class="c-red1 ts-s" [innerHTML]="creditCardDisclaimer"></div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="col pt-2 pb-2 mb-5">
        <p class="c-red1 ts-s">
          For security reasons, we do not collect Credit Card information.
          By clicking 'Continue' you are leaving the {{stateName}} SDU Internet Payment Web Site
          and will be taken to our credit card processor's web site to pay with your credit card.
        </p>
      </div>
      <div class="flex-btn-row pt-2 pb-2">
        <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
        <button class="btn btn-primary-short" [disabled]="disableCreatePaymentButton"
          (click)="createCCPayment()">{{createPaymentButtonText}}</button>
      </div>
    </div>
  </div>
  
  <!-- <epay-lib-common-creditcard-civitek *ngIf="goToCivitek" [creditCardUrl]="creditCardUrl" [originKey]="civitekOriginKey"
    [amount]="creditCardPayment?.amount!" [transactionId]="transactionId">
  </epay-lib-common-creditcard-civitek> -->
  
  <!-- <epay-lib-common-creditcard-fortpoint *ngIf="goToFortPoint" [creditCardUrl]="creditCardUrl"
    [stateCode]="fortPointStateCode" [amount]="creditCardPayment?.amount!" [transactionId]="transactionId">
  </epay-lib-common-creditcard-fortpoint> -->

  <emp-cc-fort-point *ngIf="goToFortPoint" [creditCardUrl]="creditCardUrl"
  [stateCode]="fortPointStateCode" [amount]="creditCardPayment?.amount!" [transactionId]="transactionId"></emp-cc-fort-point>